// extracted by mini-css-extract-plugin
module.exports = {"header":"_5DXDXcU2","main":"_5D3vsRfs","button__text":"_5DnRSFWd","button__icon":"_5D1JwwuP"};